<template>
    <div class="find-a-doctor-text-filter">
        <label class="label find-a-doctor-text-filter__label" :for="`text-filter-${_uid}`" v-text="label" v-if="label" />
        <input
            class="input find-a-doctor-text-filter__input"
            type="text"
            :value="value"
            :id="`text-filter-${_uid}`"
            @input="$emit('input', $event.target.value)"
            :disabled="disabled"
        >
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            defualt: '',
        },
        label: {
            type: String,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {
      if (this.defaultValue) {
            this.text = this.defaultValue;
        }
    },
}
</script>
